import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, MenuController, Platform } from '@ionic/angular';
import { DocumentViewer, DocumentViewerOptions } from '@ionic-native/document-viewer/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';
@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  isIos = false;

  constructor(private router: Router, 
              private alertController: AlertController, 
              private menuCtrl: MenuController,
              private platform: Platform) {
    this.menuCtrl.enable(false);
    if(this.platform.is('ios')) this.isIos = true;
  }

  navToSpeakers(){
    this.router.navigateByUrl('/speakers');
  }
  async presentAgendaAlert() {
    const alert = await this.alertController.create({
      message:'Please select a day',
      buttons: [
        {
          text: 'September 23, Monday',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'Sunday 22 September',
          handler: () => {
          }
        }, {
          text: 'Monday 23 September',
          handler: () => {
          }
        }, {
          text: 'Tuesday 24 September',
          handler: () => {
          }
        }, {
          text: 'Wednesday 25 September',
          handler: () => {
          }
        }, {
          text: 'Thursday 26 September',
          handler: () => {
          }
        }, {
          text: 'Friday 27 September',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }
  async presentEventInfoAlert() {
    const alert = await this.alertController.create({    
      mode:'ios',
      
      buttons: [
        {
          text: 'Travel',
          cssClass: 'secondary',
          handler: () => {
            this.openTravelLink();
          }
        }, {
          text: 'Venue',
          cssClass: 'secondary',
          handler: () => {
            this.openMeetingVenueLink();
          }
        }, {
          text: 'UMC',
          cssClass: 'secondary',
          handler: () => {
            this.openAboutUMCLink();
          }
        }
      ]
    });

    await alert.present();
  }
  
  
  openUMCLinkForHome(){
  //  window.open("http://www.underwatermining.org/",'_system', 'location=yes');
  }
  openTravelLink(){
    this.router.navigateByUrl('/travel-details');
    // window.open("http://www.underwatermining.org/UMC_travel.htm",'_system', 'location=yes');
  }
  openAboutUMCLink(){
    this.router.navigateByUrl('/umcdetails');
    //window.open("http://www.underwatermining.org/UMC_history.htm",'_system', 'location=yes');
  }
  openMeetingVenueLink(){
    this.router.navigateByUrl('/venue-details');
 
  }
  openAbstract(){
    this.router.navigateByUrl('/abstracts');
  }
  openNotesScreen(){
    window.open("https://umc-screen.firebaseapp.com/home",'_system', 'location=yes');
  }
}
